import React, { useEffect } from 'react';

import { getConfig, setConfig } from '@zimpel/common/config';
import { useNotificationContext } from '@zimpel/AppContext';
import Notification, { HEADER_NOTIFICATION_WIDTH } from './Notification';

interface NotificationContainerProps {
  offsetX?: number;
  offsetY?: number;
}

const LoggedOutNotificationContainer: React.FC<NotificationContainerProps> = ({ offsetX, offsetY }) => {
  const { notification, notify } = useNotificationContext();

  useEffect(() => {
    // Notifications from the backend
    const { flash } = getConfig();
    if (flash.length > 0) {
      flash.forEach(notify);
      setConfig({ flash: [] });
    }
  }, []);

  if (!notification) {
    return null;
  }

  return <Notification width={HEADER_NOTIFICATION_WIDTH} offsetX={offsetX} offsetY={offsetY} {...notification} />;
};

export default LoggedOutNotificationContainer;
